import { render, staticRenderFns } from "./AddressesModal.vue?vue&type=template&id=51994397&"
import script from "./AddressesModal.vue?vue&type=script&lang=js&"
export * from "./AddressesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports